import styled from 'styled-components';
import { usePaymentSessionMetadata } from '@elfsight/lib-stripe-integration';
import { Show } from '@elfsight/lib-utils';
import { Popup } from '@elfsight/widget-modal';
import { useCheckoutNarrowness } from '../components';
import {
  useCheckoutColors,
  useCheckoutNavigation
} from '../components/providers';
import { BACKDROP_COLOR } from './constants';
import { NarrowLayout } from './narrow-layout-variant';
import type { CheckoutComponentLayoutDistilledProps } from './types';
import { WideLayout } from './wide-layout-variant';

export function CheckoutComponentLayout({
  fullscreen,
  ...forwardingProps
}: CheckoutComponentLayoutDistilledProps) {
  const isNarrow = useCheckoutNarrowness();
  const { isPaymentInProcess } = usePaymentSessionMetadata();
  const { isCheckoutOpen, closeCheckoutComponent } = useCheckoutNavigation();
  const { textColor70A } = useCheckoutColors();

  const popupMargin = isNarrow ? 0 : 40;
  const canClose = !isPaymentInProcess;

  return (
    <LayoutPopup
      show={isCheckoutOpen}
      backdropColor={BACKDROP_COLOR}
      width="100%"
      closeOnEscape={canClose}
      closeOnOutsideClick={canClose}
      onCloseRequest={closeCheckoutComponent}
      margin={popupMargin}
      closeControlPosition="inside"
      fullscreen={isNarrow || fullscreen}
      closeControlColor={textColor70A}
      withCloseControl
      disableScroll
      fixed
      fit
      // нативное решение попапа по какой-то причине не работает
      $disabled={isPaymentInProcess}
    >
      <Show when={isNarrow} fallback={<WideLayout {...forwardingProps} />}>
        <NarrowLayout {...forwardingProps} />
      </Show>
    </LayoutPopup>
  );
}

const LayoutPopup = styled(Popup)<{
  $disabled: boolean;
}>`
  max-width: 1000px;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;
